import { render, staticRenderFns } from "./AsideComponent.vue?vue&type=template&id=7bcb0634"
import script from "./AsideComponent.vue?vue&type=script&lang=js"
export * from "./AsideComponent.vue?vue&type=script&lang=js"
import style0 from "./AsideComponent.vue?vue&type=style&index=0&id=7bcb0634&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports